import _ from "lodash";
import React, { memo } from "react";
import { useSortable } from "@dnd-kit/sortable";
import TableRow from "./TableRow.js";
import { colors } from "@toddle-edu/ds-theme";

const DraggableRow = props => {
  const { row, rowRefsAndHandlers, setRowRefs } = props;
  const rowId = _.get(row, "id");

  const {
    setNodeRef,
    isDragging,
    attributes,
    listeners,
    node,
    setActivatorNodeRef,
  } = useSortable({
    id: rowId,
  });

  rowRefsAndHandlers.current[rowId] = {
    id: rowId,
    listeners,
    attributes,
    ref: node,
    setActivatorNodeRef,
  };
  setRowRefs({ rowId, ref: node });

  const tableRowStyles = {
    opacity: isDragging ? 0.4 : 1,
    ...(isDragging && {
      backgroundColor: colors.surfaceHover,
    }),
  };

  return (
    <TableRow
      {...props}
      ref={setNodeRef}
      dragAttributes={attributes}
      dragListeners={listeners}
      tableRowStyles={tableRowStyles}
    />
  );
};

export default memo(DraggableRow);
